function extractURLSearchParams(search) {
  const [...params] = new URLSearchParams(search).entries();
  return params.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}

export { extractURLSearchParams };
